module.exports = __webpack_public_path__ + "img/7-Pregnancy.a125ab50.png";